import { Navigate } from "react-router-dom";
import { useAuthState } from "@/hooks/useAuthState";
import { useRecepcionistaRedirect } from "@/hooks/useRecepcionistaRedirect";
import { LoadingState } from "./LoadingState";

export const RecepcionistaRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuthState();
  const { isRecepcionista, isCheckingRole } = useRecepcionistaRedirect();

  if (loading || isCheckingRole) {
    return <LoadingState />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/intro" replace />;
  }

  if (!isRecepcionista) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
